<div class="wrapper">
  @switch (type) {
    @case ('button') {
      <div class="actions-wrapper">
        <button
          (mouseover)="tooltipOnHover.show()"
          (click)="copy();tooltipOnClick.show()"
          (mouseleave)="tooltipOnHover.hide(); tooltipOnClick.hide()"
          aria-label="Button that copies the text"
          class="button">
          <span> {{ copyLabel }} </span>
        </button>
      </div>
    }
    @case ('link') {
      <span class="link"
            (mouseover)="tooltipOnHover.show()"
            (click)="copy();tooltipOnClick.show()"
            (mouseleave)="tooltipOnHover.hide(); tooltipOnClick.hide()"> {{copyLabel}} </span>
    }
    @case ('icon') {
      <div
        class="icon-block"
        [class]="{ 'blue-border': iconBlueBorderStyle }"
        (mouseover)="tooltipOnHover.show()"
        (click)="copy(); tooltipOnClick.show()"
        (mouseleave)="tooltipOnHover.hide(); tooltipOnClick.hide()"
      >
        @if (copyLink) {
          <img
            src="./assets/img/icons/copy-link.svg" alt=""
            width="18"
            height="20"
          >
        }
        @else {
          <svg-icon-sprite
            src="./assets/img/icons/sprite.svg#copy"
            width="16px"
            height="16px"
          />
        }
      </div>
    }
    @case ('button-border') {
      <div class="actions-wrapper">
        <button
          (mouseover)="tooltipOnHover.show()"
          (click)="copy();tooltipOnClick.show()"
          (mouseleave)="tooltipOnHover.hide(); tooltipOnClick.hide()"
          aria-label="Button that copies the text"
          class="button button-border tooltip-copy-link__button tooltip-copy-link__button--border"
        >
          <svg width="14" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.762 14.526h7.816V4.708H4.762v9.818zm7.817-11.22H4.764c-.782 0-1.421.63-1.421 1.402v9.818c0 .771.64 1.403 1.42 1.403h7.816c.782 0 1.421-.632 1.421-1.403V4.708c0-.772-.639-1.403-1.42-1.403zM10.447.5H1.921C1.139.5.5 1.131.5 1.903v9.818h1.421V1.903h8.526V.5z" fill="#0D88E7"/></svg>
          @if (copyLabel) {
            <span class="tooltip-copy-link__button-label">{{ copyLabel }}</span>
          }
        </button>
      </div>
    }
  }

  <span mat-raised-button #tooltipOnHover="matTooltip"
        matTooltip="{{copyTooltipLabel}}"
        matTooltipPosition="above"
        matTooltipShowDelay="700"
        matTooltipHideDelay="1000"
        class="tooltip-message"
        matTooltipClass="tooltip-message"></span>

  <span mat-raised-button #tooltipOnClick="matTooltip"
        matTooltip="{{copiedTooltipLabel}}"
        matTooltipPosition="above"
        matTooltipHideDelay="1500"
        class="tooltip-message"
        matTooltipClass="tooltip-message"></span>
</div>

<div #container class="stash"></div>
